import { render, staticRenderFns } from "./QuestionDenied.vue?vue&type=template&id=420e37c1&"
import script from "./QuestionDenied.vue?vue&type=script&lang=js&"
export * from "./QuestionDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports